import { render, staticRenderFns } from "./DigitalCountByTypeStatisticsPage.vue?vue&type=template&id=421640ee&scoped=true&"
import script from "./DigitalCountByTypeStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./DigitalCountByTypeStatisticsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421640ee",
  null
  
)

export default component.exports